export enum EventFromEnum {
  landing = "landing",
  events = "events",
}
